// store/useDataStore.js
import { create } from "zustand";

const useOddsDataStore = create((set) => ({
  oddsData: {},

  setData: (payload) => set({ oddsData :{...payload} }),

  clearData: () => set({oddData: {}}),
}));

export default useOddsDataStore;